const SPECIES_ALIASES = {
  zebra: 'burchells zebra',
  zebras: 'burchells zebra',
};

export function normalizeSpeciesForComparison(value) {
  const normalized = typeof value === 'string'
    ? value
      .trim()
      .toLocaleLowerCase()
      .replace(/['’]s\b/g, 's')
      .replace(/[_-]+/g, ' ')
      .replace(/[^a-z0-9 ]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
    : '';

  return SPECIES_ALIASES[normalized] || normalized;
}

export function areEquivalentSpecies(firstSpecies, secondSpecies) {
  const first = normalizeSpeciesForComparison(firstSpecies);
  const second = normalizeSpeciesForComparison(secondSpecies);
  return Boolean(first && second && first === second);
}
